/**
 * live-streaming-message
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2021 Mediatel Limited.
 */

"use strict";

import numberFormat from "../../common/number-format";

export default (row, decimals) => {
    const messages = [];

    if (row.sky_playtime > 0) {
        messages.push(`Sky Go: ${numberFormat(row.sky_playtime, decimals)}`);
    }

    if (row.bbc_playtime > 0) {
        messages.push(`BBC iPlayer: ${numberFormat(row.bbc_playtime, decimals)}`);
    }

    if (row.my5_playtime > 0) {
        messages.push(`My5: ${numberFormat(row.my5_playtime, decimals)}`);
    }

    if (row.itvstv_playtime > 0) {
        messages.push(`STV Player: ${numberFormat(row.itvstv_playtime, decimals)}`);
    }

    return `${row.name} playtime on other platforms:<br> ${messages.join('<br>')}`;
};
